import { SmartAccountType } from "@wallet-manager/node-types/dist/src/postgres/const";
import { enumChainIdToType } from "src/utils/constant";

export const getTronSmartAccountType = (
  chainType: number | string,
  isSmartAccount: boolean
) => {
  const isTron = enumChainIdToType.TRON === String(chainType);

  if (!isTron) {
    return undefined;
  }

  if (!isSmartAccount) {
    return SmartAccountType.EOA;
  }

  return isSmartAccount
    ? SmartAccountType.TronRentalEnergyBandwidth
    : SmartAccountType.EOA;
};
